import { apiGetAuth, apiPutAuth } from '@/utils/api'
import { API_MASTER_DATA } from '@/utils/api-url'
import {
  notificationDanger
} from '@/utils/notification'

const state = () => {
  return {
    term_condition: { data: {} },
    tnc_voucher_digital_partner: { data: {} },
    tnc_voucher_digital_consumer: { data: {} },
    data_modal_add_edit: {},
    toggle_modal_add_edit_discard: {
      targetModals: false,  
      title: '', 
      description: '',
      customTitleBtnOk: '',
      customClass: '',
      type: '',
      loading: false
    }
  }
}

const mutations = {
  SET_TERM_CONDITION(state, payload) {
    state.term_condition = payload
  },
  SET_TNC_VOUCHER_DIGITAL_PARTNER(state, payload) {
    state.tnc_voucher_digital_partner = payload
  },
  SET_TNC_VOUCHER_DIGITAL_CONSUMER(state, payload) {
    state.tnc_voucher_digital_consumer = payload
  },
  SET_DATA_MODAL_ADD_EDIT (state, payload) {
    state.data_modal_add_edit = payload
  },
  SET_TOGGLE_MODAL_ADD_EDIT_DISCARD (state, payload) {
    state.toggle_modal_add_edit_discard = payload
  }
}

const actions = {
  async getListTermCondition (context) {
    try {
      const response = await apiGetAuth(API_MASTER_DATA.TERM_CONDITION)
      context.commit('SET_TERM_CONDITION', response.data.data)
    } catch (error) {
      notificationDanger(error)
    }
  },
  async updateTermCondition (context, payload) {
    try {
      const response = await apiPutAuth(API_MASTER_DATA.TERM_CONDITION + `?language_type=${payload.type}`, payload.reqBody)
      return response.data
    } catch (error) {
      notificationDanger(error)
    }
  },
  // Voucher Digital Partner
  async getTncVoucherDigitalPartner (context) {
    try {
      const response = await apiGetAuth(API_MASTER_DATA.TNC_VOUCHER_DIGITAL_PARTNER)
      context.commit('SET_TNC_VOUCHER_DIGITAL_PARTNER', response.data.data)
    } catch (error) {
      notificationDanger(error)
    }
  },
  async updateTncVoucherDigitalPartner (context, payload) {
    try {
      const response = await apiPutAuth(API_MASTER_DATA.TNC_VOUCHER_DIGITAL_PARTNER + `?language_type=${payload.type}`, payload.reqBody)
      return response.data
    } catch (error) {
      notificationDanger(error)
    }
  },
  // Voucher Digital Consumer
  async getTncVoucherDigitalConsumer (context) {
    try {
      const response = await apiGetAuth(API_MASTER_DATA.TNC_VOUCHER_DIGITAL_CONSUMER)
      context.commit('SET_TNC_VOUCHER_DIGITAL_CONSUMER', response.data.data)
    } catch (error) {
      notificationDanger(error)
    }
  },
  async updateTncVoucherDigitalConsumer (context, payload) {
    try {
      const response = await apiPutAuth(API_MASTER_DATA.TNC_VOUCHER_DIGITAL_CONSUMER + `?language_type=${payload.type}`, payload.reqBody)
      return response.data
    } catch (error) {
      notificationDanger(error)
    }
  }
}

const getters = {
  list_term_condition (state) {
    return state.term_condition
  },
  tnc_voucher_digital_partner (state) {
    return state.tnc_voucher_digital_partner
  },
  tnc_voucher_digital_consumer (state) {
    return state.tnc_voucher_digital_consumer
  },
  get_data_modal_add_edit (state) {
    return state.data_modal_add_edit
  },
  get_toggle_modal_add_edit_discard (state) {
    return state.toggle_modal_add_edit_discard
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
